import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, createContext, useCallback, useState } from "react";
import { useProductsDynamicData } from "../../hooks/useEssentialProductData/useEssentialProductData";
import { Carousel } from "../Carousel";
import { ContainerHeader } from "../ContainerHeader";
import { Column, Row } from "../Row";
import styles from "./ProductCardContainer.module.scss";
export const ProductCardContainerContext = createContext({
    productsSkus: {},
    products: {},
});
export const ProductCardContainer = ({ children, isCarousel, title, ctaHref, ctaLabel, desktopItemCount = 3, tabletItemCount = 2, }) => {
    const [productsSkus, setProductsSkus] = useState({});
    const { products, currency, isProductsDataLoaded } = useProductsDynamicData({
        productsSkus: Object.keys(productsSkus),
    });
    const addToSkuList = useCallback((sku) => {
        setProductsSkus((prev) => ({ ...prev, [sku]: true }));
    }, []);
    return (_jsx(ProductCardContainerContext.Provider, { value: { productsSkus, addToSkuList, products, currency, isProductsDataLoading: !isProductsDataLoaded }, children: _jsxs("div", { className: styles.content, children: [_jsx(ContainerHeader, { title: title, ctaHref: ctaHref, ctaLabel: ctaLabel }), isCarousel ? (_jsx(Carousel, { tabletItemCount: tabletItemCount, desktopItemCount: desktopItemCount, children: children })) : (_jsx(Row, { children: Children.map(children, (child) => (_jsx(Column, { sm: 12, md: 12, lg: 4, children: child }))) }))] }) }));
};
//# sourceMappingURL=ProductCardContainer.js.map